/*
 * @Author: bill
 * @Date: 2024-05-20 16:22:30
 * @LastEditors: wangzijun@bzstech.com wangzijun@bzstech.com
 * @LastEditTime: 2024-05-21 09:05:41
 * @FilePath: /study/src/routes/index.tsx
 * @Description:
 */
import { Route } from "react-router-dom";
import { routes, IRoute } from "./routes";

export const RouteData = (data: any[]) => {
  return data.map((item: IRoute, index: number) => {
    return (
      <Route
        key={item?.key ? item?.key : index}
        path={item?.path}
        element={item.element}
        caseSensitive={item?.caseSensitive}
      >
        {item?.children && RouteData(item?.children)}
      </Route>
    );
  });
};

export const routeRender = RouteData(routes);
